const KEY = "ak9_signup_source";

// First-touch attribution: capture UTM params + referrer + landing path
// on the very first page load and freeze them until signup.
export function captureSignupSource() {
  try {
    if (localStorage.getItem(KEY)) return;
    const p = new URLSearchParams(window.location.search);
    const src = {
      utm_source: p.get("utm_source") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "",
      referrer: document.referrer || "",
      landing_path: window.location.pathname || "/",
    };
    localStorage.setItem(KEY, JSON.stringify(src));
  } catch { /* private mode */ }
}

export function getSignupSource() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}
